import { styled, Typography } from "@mui/material";

export const StyledTypography = styled(Typography)({
  marginBottom: "8px",
  "& a": {
    fontWeight: 500,
  },
});
